import React, { useEffect, useState } from 'react';

import { Checkbox, makeStyles } from '@material-ui/core';
import { Map } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardFooter from 'components/Card/CardFooter';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Badge from 'components/Badge/Badge.js';
import moment from 'moment';

import { WithApp } from 'contexts/appContext';
import { wsCreate } from 'services/WService';
import useDebounce from 'hooks/useDebounce';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columnsOrders = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 90 },
  { Header: 'Ruta', accessor: 'base_route_description', width: 150 },
  { Header: 'Fecha', accessor: 'date_order', width: 110 },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'Cod. Cliente', accessor: 'CardCode', width: 120 },
  { Header: 'Cliente', accessor: 'CardName' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Unid.', accessor: 'units', width: 60 },
  { Header: 'Paq.', accessor: 'packages', width: 70 },
  { Header: 'Peso', accessor: 'weight', width: 80 },
  { Header: 'Vol.', accessor: 'volume', width: 80 },
  { Header: 'Soles', accessor: 'total_order', width: 80 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];
const defaultCalcData = [
  {
    num: '',
    base_route_description: '',
    date_order: '',
    CardCode: '',
    CardName: '',
    Address2: 'Total',
    units: 0,
    packages: 0,
    weight: 0,
    volume: 0,
    total_order: 0,
    actions: ''
  }
];

export default WithApp(function Orders(props) {
  const classes = useStyles();
  const { idZone, dataFilter, checkedRoutes, checkedOrders, setCheckedOrders } = props;

  const [orders, setOrders] = useState([]);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [customersCheck, setCustomersCheck] = useState(0);
  const [calcTotals, setCalcTotals] = useState(defaultCalcData);

  async function listOrders(idZone, checkedRoutesIds) {
    let routeSellerIds = checkedRoutesIds.map((item) => {
      return { base_seller_id: item.base_seller_id, base_route_id: item.id };
    });
    let response = await wsCreate('sale/order/programming', {
      ...dataFilter,
      state_migrate: 'X',
      customer_count: true,
      base_zone_id: idZone,
      filters: routeSellerIds,
      saleType: 'S',
    });

    if (response.success) {
      setCheckedOrders([...response.data]);
      setOrders(response.data);
      setTotalCustomers(counReducerOrders(response.data));
    }
  }

  function deleteRow(id) {
    checkedOrders.splice(
      checkedOrders.findIndex((x) => x.id == id),
      1
    );
    setCheckedOrders([...checkedOrders]);
  }

  function calculatorTotalOrders(checkedOrders) {
    let units = 0;
    let packages = 0;
    let weight = 0;
    let volume = 0;
    let total_order = 0;
    for (let obj of checkedOrders) {
      units += parseFloat(obj.units);
      packages += parseFloat(obj.packages);
      weight += parseFloat(obj.weight);
      volume += parseFloat(obj.volume);
      total_order += parseFloat(obj.total_order);
    }
    setCalcTotals([
      {
        units: units,
        packages: packages,
        weight: weight,
        volume: volume,
        total_order: total_order
      }
    ]);
  }

  function counReducerOrders(dataOrders) {
    const setObj = new Set(); // crea pares de clave y array

    const unicos = dataOrders.reduce((contador, obj) => {
      if (!setObj.has(obj.base_address_id)) {
        setObj.add(obj.base_address_id, obj);
        contador.push(obj);
      }
      return contador;
    }, []);
    return unicos.length;
  }

  useEffect(() => {
    if (checkedOrders.length > 0) {
      calculatorTotalOrders(checkedOrders);
      setCustomersCheck(counReducerOrders(checkedOrders));
    } else {
      setCalcTotals(defaultCalcData);
      setCustomersCheck(0);
    }
  }, [checkedOrders]);

  const debouncedCheckedRoutes = useDebounce(checkedRoutes, 1000);
  useEffect(() => {
    if (debouncedCheckedRoutes.length > 0) {
      listOrders(idZone, debouncedCheckedRoutes);
    } else {
      setOrders([]);
      setCheckedOrders([]);
    }
  }, [idZone, debouncedCheckedRoutes, dataFilter]);

  return (
    <>
      {checkedRoutes.length > 0 ? (
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Map />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado Pedidos</h4>
          </CardHeader>
          <CardBody>
            <GridContainer style={{ alignItems: 'center' }}>
              <GridItem sm={12} md={12} xl={2} xs={12}>
                <Checkbox
                  edge="start"
                  checked={checkedOrders.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setCheckedOrders([...orders]);
                    } else {
                      setCheckedOrders([]);
                    }
                  }}
                  indeterminate={
                    checkedOrders.length < 1 ? false : checkedOrders.length != orders.length
                  }
                  tabIndex={-1}
                  style={{ marginLeft: '13px' }}
                />
                <b>Marcar todo</b>
              </GridItem>
              <GridItem sm={6} md={3} xl={2} xs={12}>
                <span>
                  <b>Total Clientes: {totalCustomers}</b>
                </span>
              </GridItem>
              <GridItem sm={6} md={3} xl={2} xs={12}>
                <span>
                  <b>
                    Clientes seleccionados: {customersCheck}
                    {/* totalCustomers.customer_count - totalCustomers.uck_customers.length */}
                  </b>
                </span>
              </GridItem>
              <GridItem sm={6} md={3} xl={2} xs={12}>
                <span>
                  <b>Total Órdenes: {orders.length}</b>
                </span>
              </GridItem>
              <GridItem sm={6} md={3} xl={2} xs={12}>
                <span>
                  {/* <b>Ordenes seleccionadas: {orders.length - totalCustomers.uck_orders.length}</b> */}
                  <b>Órdenes seleccionadas: {checkedOrders.length}</b>
                </span>
              </GridItem>
              <GridItem sm={12} xl={8} xs={12} className={classes.containRoutes}>
                <span>
                  <b>Rutas: </b>
                </span>
                {checkedRoutes.map((item, i) => {
                  return (
                    <Badge
                      key={item.id + item.base_seller_id}
                      color={'info'}
                      style={{ marginRight: '7px', fontSize: '12px' }}
                    >
                      {item.code}
                    </Badge>
                  );
                })}
              </GridItem>
            </GridContainer>
            <hr className={classes.hr} />
            <ReactTable
              excelName="Pedidos_programación"
              defaultWidth={1540}
              indexColumn={[7, 8, 9, 10, 11]}
              alignColumn={['right', 'right', 'right', 'right', 'right']}
              columns={columnsOrders}
              colorRow={(item) => {
                return item.groupnum != -1 ? '#ff73732e' : '';
              }}
              data={orders.map((item, i) => {
                return {
                  num: (
                    <>
                      <Checkbox
                        edge="start"
                        disableRipple
                        checked={checkedOrders.some((obj) => obj.id == item.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setCheckedOrders([...checkedOrders, item]);
                          } else {
                            deleteRow(item.id);
                          }
                        }}
                        tabIndex={-1}
                      />
                      {i + 1}
                    </>
                  ),
                  base_route_description: item.base_route_description,
                  date_order: moment(item.date_order).format('DD-MM-YYYY'),
                  SlpName: item.SlpName,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  Address2: item.Address2,
                  units: parseInt(item.units || 0),
                  packages: parseInt(item.packages || 0),
                  weight: parseFloat(item.weight || 0).toFixed(2),
                  volume: parseFloat(item.volume || 0).toFixed(2),
                  total_order: currency(item.total_order),
                  groupnum: item.groupnum,
                  actions: ''
                };
              })}
            />
          </CardBody>
          <CardFooter style={{ display: 'block' }}>
            <ReactTable
              pagination={false}
              showHeader={false}
              exportExcel={false}
              defaultWidth={1540}
              indexColumn={[7, 8, 9, 10, 11]}
              alignColumn={['right', 'right', 'right', 'right', 'right']}
              columns={columnsOrders}
              data={
                calcTotals?.map((item, i) => {
                  return {
                    num: '',
                    base_route_description: '',
                    date_order: '',
                    SlpName: '',
                    CardCode: '',
                    CardName: '',
                    domicilio_id: <b>Total</b>,
                    units: <b>{item.units || 0}</b>,
                    packages: <b>{item.packages || 0}</b>,
                    weight: <b>{(item.weight || 0).toFixed(2)}</b>,
                    volume: <b>{(item.volume || 0).toFixed(2)}</b>,
                    total_order: <b>{(item.total_order || 0).toFixed(2)}</b>,
                    actions: ''
                  };
                }) || []
              }
            />
          </CardFooter>
        </Card>
      ) : undefined}
    </>
  );
});
